export default {
    IntervalDay: 'چند روز در میان',
    IntervalDayMin: 'چند روز در میان از',
    IntervalDayMax: 'چند روز در میان تا',
    MaximumOrderQuantity: 'بیشترین مقدار سفارش',
    MaximumOrderQuantityMin: 'بیشترین مقدار سفارش از',
    MaximumOrderQuantityMax: 'بیشترین مقدار سفارش تا',
    MinimumOrderQuantity: 'کمترین مقدار سفارش',
    MinimumOrderQuantityMin: 'کمترین مقدار سفارش از',
    MinimumOrderQuantityMax: 'کمترین مقدار سفارش تا',
    Slug: 'slug',
    SortOrder: 'ترتیب نمایش',
    Title: 'عنوان'
}